import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandL, BrandXXL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Container = styled(Horizontal).attrs({
  gap: 4,
  center: true,
})`
  flex-wrap: wrap;
`;

const FigureContainer = styled(Vertical).attrs({
  gap: 2,
  center: true,
})`
  min-width: calc(var(--unit) * 25);
  padding: var(--double-unit);
  border-radius: var(--double-unit);
  border-right: 1px solid var(--c-nd-900-opaque);
  border-bottom: 1px solid var(--c-nd-900-opaque);
  &:hover {
    transform: scale(1.015);
  }
`;

const Figure = styled(BrandXXL)`
  @media ${tabletAndAbove} {
    word-break: break-word;
  }
`;

export const ByTheNumbers = () => {
  const isLaptop = useIsLaptop();
  return (
    <Vertical gap={isLaptop ? 6 : 2} center>
      <BrandL>
        <FormattedMessage
          id="figures.title"
          defaultMessage="Sorare by the numbers"
        />
      </BrandL>
      <Container>
        <FigureContainer>
          <Figure>3M</Figure>
          <BodyM>
            <FormattedMessage id="figures.users" defaultMessage="Users" />
          </BodyM>
        </FigureContainer>
        <FigureContainer>
          <Figure>300+</Figure>
          <BodyM>
            <FormattedMessage id="figures.partners" defaultMessage="Partners" />
          </BodyM>
        </FigureContainer>
        <FigureContainer>
          <Figure>180+</Figure>
          <BodyM>
            <FormattedMessage id="figures.markets" defaultMessage="Markets" />
          </BodyM>
        </FigureContainer>
        <FigureContainer>
          <Figure>$769m</Figure>
          <BodyM>
            <FormattedMessage
              id="figures.fundraising"
              defaultMessage="Fundraising"
            />
          </BodyM>
        </FigureContainer>
        <FigureContainer>
          <Figure>110+</Figure>
          <BodyM>
            <FormattedMessage
              id="figures.employees"
              defaultMessage="Employees"
            />
          </BodyM>
        </FigureContainer>
      </Container>
    </Vertical>
  );
};
